import { render, staticRenderFns } from "./PrincipalOpcionDialog.vue?vue&type=template&id=26df1b38"
import script from "./PrincipalOpcionDialog.vue?vue&type=script&lang=js"
export * from "./PrincipalOpcionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports